import React from 'react'
import { Button, Modal, ModalBody } from 'reactstrap'
import { useTranslation } from 'react-i18next'

const ActionErrorModal = ({
  isOpen,
  toggleModal,
  title,
  message,
  icon,
  clearErrorState = null,
  primaryAction = null,
  secondaryAction = null
}) => {
  const { t } = useTranslation()

  const handlePrimaryAction = () => {
    if (primaryAction?.onClick) {
      primaryAction.onClick()
    }
    if (clearErrorState) {
      clearErrorState()
    }
  }

  const handleSecondaryAction = () => {
    if (secondaryAction?.onClick) {
      secondaryAction.onClick()
    }
    toggleModal()
    if (clearErrorState) {
      clearErrorState()
    }
  }

  const handleClose = () => {
    toggleModal()
    if (clearErrorState) {
      clearErrorState()
    }
  }

  return (
    <Modal isOpen={isOpen.keyCode === 27 ? false : isOpen} toggle={handleClose} size="lg">
      <ModalBody className="modal-body-lg text-center">
        <div className="nk-modal">
          {icon}
          <h4 className="nk-modal-title">{title}</h4>
          <div className="nk-modal-text">
            <p className="lead">
              {message}
            </p>
          </div>
          <div className="nk-modal-action mt-5">
            {primaryAction && (
              <Button
                color="primary"
                size="lg"
                className="btn-mw me-2"
                onClick={handlePrimaryAction}
              >
                {primaryAction.label}
              </Button>
            )}
            {secondaryAction && (
              <Button
                color="light"
                size="lg"
                className="btn-mw"
                onClick={handleSecondaryAction}
              >
                {secondaryAction.label}
              </Button>
            )}
            {!primaryAction && !secondaryAction && (
              <Button color="light" size="lg" className="btn-mw" onClick={handleClose}>
                {t('return')}
              </Button>
            )}
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ActionErrorModal
